export const navigation = [
  {
    label: "Reviews to products",
    labelI18n: 'reviews.tab_reviews_to_products',
    href: "/user/reviews/product",
  },
  {
    label: "Reviews to sellers",
    labelI18n: 'reviews.tab_reviews_to_sellers',
    href: "/user/reviews/seller",
  },
]
